import './AlertRules.scss'
import React, {useEffect, useState} from 'react';
import {Row, Col, Icon, Button, Card, Spin, Pagination, Table, Descriptions, Modal} from 'antd'
import { useTranslation } from 'react-i18next';
import { camelizerHelper } from '../../../../helpers';
import AnimateHeight from 'react-animate-height';
import moment from 'moment';
import { FalsesPositivesBlock } from '../../../AlertManager/components';
import apiConfig from '../../../../config/api'
import DOMPurify from 'dompurify';

const AlertRules = ({alert, refreshHandler, origin, setFalsosPositivos, currentUser}) => {
  const { t } = useTranslation('translations');
  const [seeMore, setSeeMore] = useState('auto');
  const [tabla1Data, setTabla1Data] = useState([]);
  const [tabla2Data, setTabla2Data] = useState([]);
  const [tabla2BData, setTabla2BData] = useState([]);
  const [tabla3Data, setTabla3Data] = useState([]);
  const [tabla4Data, setTabla4Data] = useState([]);

  const tabla1Rules = ["RE1101", "RE1102", "RE1103", "RE1104"];
  const tabla2Rules = ["RE1120", "RE1121", "RE1122", "RE1123", "RE1124", "RE1125", "RE1126", "RE1127", "RE1128", "RE1129"];
  const tabla3Rules = ["RE1105", "RE1106", "RE1107", "RE1108"];
  const tabla2BRules = ["RE1140", "RE1141", "RE1142", "RE1143"];
  const tabla4Rules = ["RE1150", "RE1151", "RE1152", "RE1153"];
  const [trxDetails, setTrxDetails] = useState([]);

  useEffect(() => {
      if (alert && alert.riskRecords) {
        const filteredTabla1 = alert.riskRecords.filter(item => tabla1Rules.includes(item.ruleId));
        setTabla1Data(filteredTabla1);

        const filteredTabla2 = alert.riskRecords.filter(item => tabla2Rules.includes(item.ruleId));
        setTabla2Data(filteredTabla2);

        const filteredTabla3 = alert.riskRecords.filter(item => tabla3Rules.includes(item.ruleId));
        setTabla3Data(filteredTabla3);

        const filteredTabla2B = alert.riskRecords.filter(item => tabla2BRules.includes(item.ruleId));
        setTabla2BData(filteredTabla2B);

        const filteredTabla4 = alert.riskRecords.filter(item => tabla4Rules.includes(item.ruleId));
        setTabla4Data(filteredTabla4);
      }
    }, [alert]);
  const updateFP = (fps) => {
    setFalsosPositivos(fps)
  }

  const downloadReportRisk = (pdfFile) => {
    window.open(apiConfig.url + '/ubo/getPDFUboFinder?path=' + pdfFile)
  }

  const quiebrasColumn = [
    {
      title: t('messages.aml.rut'),
      dataIndex: 'rut'
    },
    {
      title: t('messages.aml.modalAlert.alertRules.bankruptcyCourt'),
      dataIndex: 'tribunal'
    },
    {
      title: t('messages.aml.modalAlert.alertRules.bankruptcyAuctioneer'),
      dataIndex: 'martillero'
    },
    {
      title: t('messages.aml.stage'),
      dataIndex: 'etapa'
    },
    {
      title: t('messages.aml.date'),
      dataIndex: 'fecha'
    },
    {
      title: t('messages.aml.risk'),
      dataIndex: 'risk',
      render: (risk) => {
        return(
          <div className={ 'child-risk risk-' + risk }>
            { risk === null && t('messages.aml.nA')}
            { risk === 'BLACK' && 'C' }
            { risk === 'RED' && 'A' }
            { risk === 'ORANGE' && 'M' }
            { risk === 'YELLOW' && 'B' }
            { risk === 'GREEN' && 'N' }
          </div>
        )
      }
    }
  ]

  const alertRiskDetailColumns = [
    {
      key: 'type',
      title: t('messages.aml.type'),
      dataIndex: "type",
      render: (type) => {
        return type === 'UBO' ? type : t('messages.aml.' + type.toLowerCase())
      }
    },
    {
      key: 'name',
      title: t('messages.aml.name'),
      dataIndex: "name",
      render: (name) =>{
        return camelizerHelper(name)
      }
    },
    {
      key: 'rut',
      title: t('messages.aml.rut'),
      dataIndex: 'rut',
      render: (rut) => {
        return rut !== null ? rut : t('messages.aml.notFound')
      }
    },
    {
      key: 'db',
      title: t('messages.aml.databases'),
      dataIndex: 'basesAML'
    },
    {
      key: 'rulesId',
      title:  t('messages.aml.rules'),
      dataIndex: 'rulesId',
      render: (rulesId) => {
        return rulesId !== null && rulesId.join(', ')
      }
    },
    {
      key: 'risk',
      title: t('messages.aml.risk'),
      dataIndex: 'risk',
      render: (risk) => {
        return(
          <div className={ 'child-risk risk-' + risk }>
            { risk === null && t('messages.aml.nA')}
            { risk === 'BLACK' && 'C' }
            { risk === 'RED' && 'A' }
            { risk === 'ORANGE' && 'M' }
            { risk === 'YELLOW' && 'B' }
            { risk === 'GREEN' && 'N' }
          </div>
        )
      }
    },
    {
      key: 'downloadBtn',
      title: t('messages.aml.downloadReport'),
      dataIndex: 'path',
      render: (path) => {
        return (
          <div>
            <Button type="primary" icon="file-pdf" size="small" onClick={ (e) => downloadReportRisk(path) }>PDF</Button>
          </div>
        )
      }
    }
  ]

  const tabla1Columns = [
    {
      title: t('messages.aml.category'),
      dataIndex: "categoryRelated",
      render: (categoryRelated) => {
        return camelizerHelper(categoryRelated)
      }
    },
    {
      title: t('messages.aml.type'),
      dataIndex: "relRelated",
      render: (relRelated) => {
        return camelizerHelper(relRelated)
      }
    },
    {
      title: t('messages.aml.participation'),
      dataIndex: 'partRelated',
      render: (partRelated) => {
        return partRelated ? (partRelated +"%") : null
      }
    },
    {
      title: t('messages.aml.databases'),
      dataIndex: 'basesRelated'
    },
    {
      title:  t('messages.aml.rules'),
      dataIndex: 'ruleId'
    },
    {
      title: t('messages.aml.risk'),
      dataIndex: 'risk',
      render: (risk) => {
        return(
          <div className={ 'child-risk risk-' + risk }>
            { risk === null && t('messages.aml.nA')}
            { risk === 'BLACK' && 'C' }
            { risk === 'RED' && 'A' }
            { risk === 'ORANGE' && 'M' }
            { risk === 'YELLOW' && 'B' }
            { risk === 'GREEN' && 'N' }
          </div>
        )
      }
    },
    {
      title: t('messages.aml.downloadReport'),
      dataIndex: 'pdfRelated',
      render: (pdfRelated) => {
          if(pdfRelated){
          return (
            <div>
              <Button type="primary" icon="file-pdf" size="small" onClick={ (e) => downloadReportRisk(pdfRelated) }>PDF</Button>
            </div>
          )
        }
      }
    }
  ]

  const tabla3Columns = [
    {
      title: t('messages.aml.legalName'),
      dataIndex: "nameRelated",
      render: (name) =>{
        return camelizerHelper(name)
      }
    },
    {
      title: t('messages.aml.rut'),
      dataIndex: "rutRelated"
    },
    {
      title: t('messages.aml.category'),
      dataIndex: "categoryRelated",
      render: (categoryRelated) => {
        return camelizerHelper(categoryRelated)
      }
    },
    {
      title: t('messages.aml.type'),
      dataIndex: "relRelated",
      render: (relRelated) => {
        return camelizerHelper(relRelated)
      }
    },
    {
      title: t('messages.aml.participation'),
      dataIndex: 'partRelated',
      render: (partRelated) => {
        return partRelated ? (partRelated +"%") : null
      }
    },
    {
      title: t('messages.aml.databases'),
      dataIndex: 'basesRelated'
    },
    {
      title:  t('messages.aml.rules'),
      dataIndex: 'ruleId'
    },
    {
      title: t('messages.aml.risk'),
      dataIndex: 'risk',
      render: (risk) => {
        return(
          <div className={ 'child-risk risk-' + risk }>
            { risk === null && t('messages.aml.nA')}
            { risk === 'BLACK' && 'C' }
            { risk === 'RED' && 'A' }
            { risk === 'ORANGE' && 'M' }
            { risk === 'YELLOW' && 'B' }
            { risk === 'GREEN' && 'N' }
          </div>
        )
      }
    },
    {
      title: t('messages.aml.downloadReport'),
      dataIndex: 'pdfRelated',
      render: (pdfRelated) => {
          if(pdfRelated){
          return (
            <div>
              <Button type="primary" icon="file-pdf" size="small" onClick={ (e) => downloadReportRisk(pdfRelated) }>PDF</Button>
            </div>
          )
        }
      }
    }
  ]

  const tabla2Columns = [
    {
      title: t('messages.aml.name'),
      dataIndex: "nameRelated",
      render: (name) =>{
        return camelizerHelper(name)
      }
    },
    {
      title: t('messages.aml.rut'),
      dataIndex: "rutRelated"
    },
    {
      title: t('messages.aml.category'),
      dataIndex: "categoryRelated",
      render: (categoryRelated) => {
        return camelizerHelper(categoryRelated)
      }
    },
    {
      title: t('messages.aml.relationship'),
      dataIndex: "relRelated",
      render: (relRelated) => {
        return camelizerHelper(relRelated)
      }
    },
    {
      title: t('messages.aml.databases'),
      dataIndex: 'basesRelated'
    },
    {
      title:  t('messages.aml.rules'),
      dataIndex: 'ruleId'
    },
    {
      title: t('messages.aml.risk'),
      dataIndex: 'risk',
      render: (risk) => {
        return(
          <div className={ 'child-risk risk-' + risk }>
            { risk === null && t('messages.aml.nA')}
            { risk === 'BLACK' && 'C' }
            { risk === 'RED' && 'A' }
            { risk === 'ORANGE' && 'M' }
            { risk === 'YELLOW' && 'B' }
            { risk === 'GREEN' && 'N' }
          </div>
        )
      }
    },
    {
      title: t('messages.aml.downloadReport'),
      dataIndex: 'pdfRelated',
      render: (pdfRelated) => {
          if(pdfRelated){
          return (
            <div>
              <Button type="primary" icon="file-pdf" size="small" onClick={ (e) => downloadReportRisk(pdfRelated) }>PDF</Button>
            </div>
          )
        }
      }
    }
  ]

  const tabla2BColumns = [
    {
      title: t('messages.aml.modalAlert.alertRules.relativeName'),
      render: (record) =>{
        if(record?.relations) {
          return camelizerHelper(record.relations[0].name)
        }
      }
    },
    {
      title: t('messages.aml.modalAlert.alertRules.relativeRut'),
      render: (record) =>{
        if(record?.relations) {
          return camelizerHelper(record.relations[0].rut)
        }
      }
    },
    {
      title: t('messages.aml.modalAlert.alertRules.kinship'),
      render: (record) =>{
        if(record?.relations) {
          return camelizerHelper(record.relations[0].relation)
        }
      }
    },
    {
      title: t('messages.aml.category'),
      dataIndex: "categoryRelated",
      render: (categoryRelated) => {
        return camelizerHelper(categoryRelated)
      }
    },
    {
      title: t('messages.aml.type'),
      dataIndex: "relRelated",
      render: (relRelated) => {
        return camelizerHelper(relRelated)
      }
    },
    {
      title: t('messages.aml.participation'),
      dataIndex: 'partRelated',
      render: (partRelated) => {
        return partRelated ? (partRelated +"%") : null
      }
    },
    {
      title: t('messages.aml.databases'),
      dataIndex: 'basesRelated'
    },
    {
      title:  t('messages.aml.rules'),
      dataIndex: 'ruleId'
    },
    {
      title: t('messages.aml.risk'),
      dataIndex: 'risk',
      render: (risk) => {
        return(
          <div className={ 'child-risk risk-' + risk }>
            { risk === null && t('messages.aml.nA')}
            { risk === 'BLACK' && 'C' }
            { risk === 'RED' && 'A' }
            { risk === 'ORANGE' && 'M' }
            { risk === 'YELLOW' && 'B' }
            { risk === 'GREEN' && 'N' }
          </div>
        )
      }
    },
    {
      title: t('messages.aml.downloadReport'),
      dataIndex: 'pdfRelated',
      render: (pdfRelated) => {
          if(pdfRelated){
          return (
            <div>
              <Button type="primary" icon="file-pdf" size="small" onClick={ (e) => downloadReportRisk(pdfRelated) }>PDF</Button>
            </div>
          )
        }
      }
    }
  ]

  const tabla4Columns = [
    {
      title: "Nombre pariente",
      render: (record) =>{
        if(record?.relations) {
          return camelizerHelper(record.relations[0].name)
        }
      }
    },
    {
      title: t('messages.aml.modalAlert.alertRules.relativeRut'),
      render: (record) =>{
        if(record?.relations) {
          return camelizerHelper(record.relations[0].rut)
        }
      }
    },
    {
      title: t('messages.aml.modalAlert.alertRules.kinship'),
      render: (record) =>{
        if(record?.relations) {
          return camelizerHelper(record.relations[0].relation)
        }
      }
    },
    {
      title: t('messages.aml.legalName'),
      dataIndex: "nameRelated",
      render: (name) =>{
        return camelizerHelper(name)
      }
    },
    {
      title: t('messages.aml.rut'),
      dataIndex: "rutRelated"
    },
    {
      title: t('messages.aml.category'),
      dataIndex: "categoryRelated",
      render: (categoryRelated) => {
        return camelizerHelper(categoryRelated)
      }
    },
    {
      title: t('messages.aml.type'),
      dataIndex: "relRelated",
      render: (relRelated) => {
        return camelizerHelper(relRelated)
      }
    },
    {
      title: t('messages.aml.participation'),
      dataIndex: 'partRelated',
      render: (partRelated) => {
        return partRelated ? (partRelated +"%") : null
      }
    },
    {
      title: t('messages.aml.databases'),
      dataIndex: 'basesRelated'
    },
    {
      title:  t('messages.aml.rules'),
      dataIndex: 'ruleId'
    },
    {
      title: t('messages.aml.risk'),
      dataIndex: 'risk',
      render: (risk) => {
        return(
          <div className={ 'child-risk risk-' + risk }>
            { risk === null && t('messages.aml.nA')}
            { risk === 'BLACK' && 'C' }
            { risk === 'RED' && 'A' }
            { risk === 'ORANGE' && 'M' }
            { risk === 'YELLOW' && 'B' }
            { risk === 'GREEN' && 'N' }
          </div>
        )
      }
    },
    {
      title: t('messages.aml.downloadReport'),
      dataIndex: 'pdfRelated',
      render: (pdfRelated) => {
          if(pdfRelated){
          return (
            <div>
              <Button type="primary" icon="file-pdf" size="small" onClick={ (e) => downloadReportRisk(pdfRelated) }>PDF</Button>
            </div>
          )
        }
      }
    }
  ]

  const trxDetailsColumns = [
    { title: 'ID', dataIndex: 'id', key: 'id' },
    { title: t('messages.aml.date'), dataIndex: 'date', key: 'date' },
    { 
      title: t('messages.aml.amount'), 
      dataIndex: 'amount', 
      key: 'amount', 
      render: (amount, record) => {
        let monto = amount;
        try {
          monto = parseInt(amount, 10);
          // monto formateado a miles con separador de puntos y sin decimales
          monto = monto.toLocaleString('cl', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        }catch(e) {}
        return `${record.currency} ${monto}`;
      }
    }
  ];

  const getRiskDetailData = (key, value, index) => {
    if(key === 'TrxDetail') {
      if(value && value.length > 0) {
        const rows = value.split('^').map(item => {
          const data = item.split('_');
          return { id: data[0], date: data[1], amount: data[2], currency: data[3] };
        });
        return (
        <>
          <Col span={12}>
              Detalle Transacciones:
          </Col>
          <Col span={12}>
            <Button size="small" onClick={() => setTrxDetails(rows)}>Ver Detalle</Button>
          </Col>
        </>
        )
      }
    }else {
      return (
      <div style={{width:'100%', backgroundColor: index % 2 === 0 ? '#f0f2f5' : 'unset', margin: '-1px 0'}}>
        <Col span={12}>
            {key}:
        </Col>
        <Col span={12}>
        {Array.isArray(value)
        ? value.toString()
        : typeof value === 'string' && !value.includes('CLP')
          ? value.match(/^\d{4}-\d{2}-\d{2}/)
              ? moment(value).format('DD/MM/YYYY')
              : camelizerHelper(value)
          : value}
        </Col>
      </div>
      )
    }
  }

    return (
      <>
      {alert ?
        <div className='alert-rules-section'>
            <div className="title-section">
                <Row>
                    <Col span={19}>
                        <h3>{t('messages.aml.modalAlert.rulesTitle')}</h3>
                    </Col>
                    <Col span={5}>
                        <div style={{textAlign: 'right'}}>
                        <Button type="link" onClick={() => {setSeeMore(seeMore === 0 ? 'auto' : 0)}}>
                            {seeMore ?
                                <>{t('messages.aml.modalAlert.showLess')} <Icon type="minus"/></>
                                :
                                <>{t('messages.aml.modalAlert.showMore')} <Icon type="plus"/></>
                            }
                        </Button>
                        </div>
                    </Col>
                </Row>
                <hr/>
            </div>
            {/* {seeMore && */}
            <AnimateHeight 
                duration={ 500 } 
                height={ seeMore } 
                animateOpacity={true}
            >
                <div className='subtitle-section'>
                    <Row>
                        <Col span={24}>
                            {t('messages.aml.modalAlert.rulesPersonTitle')}
                        </Col>
                    </Row>
                </div>
                <div className='body-section-wrapper'>
                  <Row justify='start'>
                      {alert !== null &&
                          alert?.rules.map((rule) => {
                              return (
                              <div className="rules-items">
                                  <Row >
                                      <Col span={12}>
                                          <div>
                                              <strong>{ rule.name }</strong>
                                          </div>
                                      </Col>
                                      <Col span={9}>
                                          <div>
                                          { t('messages.aml.code') }: <strong>{ rule.code }</strong>
                                          </div>
                                      </Col>
                                      <Col span={3}>
                                          <div>
                                          { t('messages.aml.score') }: <strong>{ rule.score }</strong>
                                          </div>
                                      </Col>
                                  </Row>
                              </div>
                              )
                          })
                      }
                  </Row>
                </div>
                <div className='subtitle-section'>
                  <Row>
                      <Col span={24}>
                          {t('messages.aml.modalAlert.detail')}
                      </Col>
                  </Row>
                </div>
                {alert?.description?.rules &&
                  <>
                    <div className="rules-cards-wrapper">
                      { alert?.description?.rules.map((rule) =>
                        <Row type="flex" gutter={[8,16]} style={{padding:'0px 18px'}}>
                          <Col span={10}>
                            <Card bodyStyle={{textAlign: "left", verticalAlign:"center"}}>
                                {alert?.rules.map(alertRule => {
                                  if (alertRule?.code === rule.code){
                                    return <div>
                                      <p style={{marginBottom: 5}}>{alertRule?.name}:</p>
                                      <p>{alertRule?.description}</p>
                                    </div>
                                  }
                                })}
                            </Card>
                          </Col>
                            {rule?.params?.fecCierre ?
                              <>
                                <Col span={7} >
                                    <Card title={t('messages.aml.modalAlert.alertRules.currentEvent')} headStyle={{backgroundColor: '#0000004d', color: 'white'}}>
                                      <Row className="data">
                                        { rule.params.operacion &&
                                          <>
                                            <Col span={14}>
                                              {t('messages.aml.modalAlert.alertRules.operation')}:
                                            </Col>
                                            <Col span={10}>
                                                {rule.params.operacion}
                                            </Col>
                                          </>
                                        }
                                        { rule.params.monto !== undefined &&
                                          <>
                                            <Col span={14}>
                                              {t('messages.aml.amount')}:
                                            </Col>
                                            <Col span={10}>
                                              ${rule.params.monto?.toLocaleString('cl')}
                                            </Col>
                                          </>
                                        }
                                        { rule.params.fechaOperacion &&
                                          <>
                                            <Col span={14}>
                                              {t('messages.aml.date')}:
                                            </Col>
                                            <Col span={10}>
                                              {moment(rule.params.fechaOperacion).format('DD/MM/YYYY')}
                                            </Col>
                                          </>
                                        }
                                        { rule.params.aportePatrimonial ?
                                          <>
                                            <Col span={14}>
                                              {t('messages.aml.modalAlert.alertRules.capitalContribution')}:
                                            </Col>
                                            <Col span={10}>
                                                ${rule.params.aportePatrimonial?.toLocaleString('cl')}
                                            </Col>
                                          </>
                                          : rule.params.patAdministradoCurrent &&
                                          <>
                                            <Col span={14}>
                                                {t('messages.aml.modalAlert.alertRules.managedAssets')}:
                                            </Col>
                                            <Col span={10}>
                                                ${rule.params.patAdministradoCurrent?.toLocaleString('cl')}
                                            </Col>
                                          </>
                                        }
                                        <Col span={14}>
                                          { rule.params.aportePatrimonial ? `${t('messages.aml.modalAlert.alertRules.operationDate')}:`
                                          : `${t('messages.aml.modalAlert.alertRules.closingDate')}:`
                                          }
                                        </Col>
                                        <Col span={10}>
                                            {moment(rule.params.fecCierre).format('DD/MM/YYYY')}
                                        </Col>
                                        { rule.params.perfil &&
                                          <>
                                            <Col span={14}>
                                              {t('messages.aml.profile')}:
                                            </Col>
                                            <Col span={10}>
                                              {rule.params.perfil == '3' ? t('messages.aml.highRisk')
                                              : rule.params.perfil == '2' ? t('messages.aml.mediumRisk')
                                              : rule.params.perfil == '1' && t('messages.aml.lowRisk')
                                              }
                                            </Col>
                                          </>
                                        }
                                        {rule.params.pep && rule.params.pep === 'Y' &&
                                          <>
                                            <Col span={14}>
                                              PEP:
                                            </Col>
                                            <Col span={10}>
                                              {t('messages.aml.modalAlert.alertRules.yesSeeDetail')}
                                            </Col>
                                          </>
                                        }
                                        {rule.params.pais &&
                                          <>
                                            <Col span={14}>
                                              {t('messages.aml.modalAlert.alertRules.riskCountry')}:
                                            </Col>
                                            <Col span={10} style={{textTransform: 'capitalize'}}>
                                              {rule.params.pais.toLowerCase()}
                                            </Col>
                                          </>
                                        }
                                        {rule.params.actividad &&
                                          <>
                                            <Col span={14}>
                                              {t('messages.aml.modalAlert.alertRules.riskActivity')}:
                                            </Col>
                                            <Col span={10} style={{textTransform: 'capitalize'}}>
                                              {rule.params.actividad.toLowerCase()}
                                            </Col>
                                          </>
                                        }
                                      </Row>
                                    </Card>
                                </Col>
                                <Col span={7} >
                                    <Card title={t('messages.aml.modalAlert.alertRules.pastEvent')} headStyle={{backgroundColor: '#0000004d', color: 'white'}}>
                                      <Row className="data">
                                        { rule.params.patAdministrar ?
                                          <>
                                              <Col span={14}>
                                                  {t('messages.aml.modalAlert.alertRules.assetsToManage')}:
                                              </Col>
                                              <Col span={10}>
                                                  ${rule.params.patAdministrar.toLocaleString('cl')}
                                              </Col>
                                          </>
                                        : rule.params.patAdministradoPrevious &&
                                          <>
                                              <Col span={14}>
                                                  {t('messages.aml.modalAlert.alertRules.managedAssets')}:
                                              </Col>
                                              <Col span={10}>
                                                  ${rule.params.patAdministradoPrevious.toLocaleString('cl')}
                                              </Col>
                                          </>
                                        }
                                        {rule.params.fecPrevious &&
                                          <>
                                            <Col span={14}>
                                                {t('messages.aml.modalAlert.alertRules.closingDate')}:
                                            </Col>
                                            <Col span={10}>
                                              {moment(rule.params.fecPrevious).format('DD/MM/YYYY')}
                                            </Col>
                                          </>
                                        }
                                      </Row>
                                    </Card>
                                </Col>
                              </>
                            : (alert.type === "TRANSACCIONAL" || rule.params) &&
                              <Col span={14} >
                                <Card>
                                  <Row gutter={[10, 0]}>
                                    { alert.type === "TRANSACCIONAL" &&
                                      <Col span={12}>
                                        <Col span={24}><h4>{t('messages.aml.modalAlert.alertRules.transactionDataTitle')}</h4></Col>
                                        <Col span={24}>
                                          <Row className="data" style={{display:"ruby"}}>
                                            <div style={{width:'100%', backgroundColor: '#f0f2f5', margin: '-1px 0'}}>
                                              <Col span={12}>
                                                  {t('messages.aml.modalAlert.alertRules.operationId')}:
                                              </Col>
                                              <Col span={12}>
                                                {alert.transaction.id ?? t('messages.aml.nA')}
                                              </Col>
                                            </div>
                                            <div style={{width:'100%', margin: '-1px 0'}}>
                                              <Col span={12}>
                                                  {t('messages.aml.modalAlert.alertRules.product')}:
                                              </Col>
                                              <Col span={12} style={alert.transaction.producto && {textTransform: 'capitalize'}}>
                                                {alert.transaction.producto ? alert.transaction.producto.toLowerCase() : alert.transaction.codProducto}
                                              </Col>
                                            </div>
                                            <div style={{width:'100%', backgroundColor: '#f0f2f5', margin: '-1px 0'}}>
                                              <Col span={12}>
                                                  {t('messages.aml.modalAlert.alertRules.operation')}:
                                              </Col>
                                              <Col span={12} style={alert.transaction.operacion && {textTransform: 'capitalize'}}>
                                                {alert.transaction.operacion ? alert.transaction.operacion.toLowerCase() : alert.transaction.codOperacion}
                                              </Col>
                                            </div>
                                            <div style={{width:'100%', margin: '-1px 0'}}>
                                              <Col span={12}>
                                                  {t('messages.aml.amount')}:
                                              </Col>
                                              <Col span={12}>
                                                {alert.transaction.monto ? alert.transaction.monto.toLocaleString('cl') + ' ' + alert.transaction.codMoneda : t('messages.aml.nA')}
                                              </Col>
                                            </div>
                                            <div style={{width:'100%', backgroundColor: '#f0f2f5', margin: '-1px 0'}}>
                                              <Col span={12}>
                                                  {t('messages.aml.balance')}:
                                              </Col>
                                              <Col span={12}>
                                                {alert.transaction.saldo ? alert.transaction.saldo.toLocaleString('cl') + ' ' + alert.transaction.codMoneda : t('messages.aml.nA')}
                                              </Col>
                                            </div>
                                            <div style={{width:'100%', margin: '-1px 0'}}>
                                              <Col span={12}>
                                                  {t('messages.aml.modalAlert.alertRules.operationDate')}:
                                              </Col>
                                              <Col span={12}>
                                                {alert.transaction.fechaOperacion ? moment(alert.transaction.fechaOperacion).format('DD/MM/YYYY') : t('messages.aml.nA')}
                                              </Col>
                                            </div>
                                            <div style={{width:'100%', backgroundColor: '#f0f2f5', margin: '-1px 0'}}>
                                              <Col span={12}>
                                                  {t('messages.aml.modalAlert.alertRules.paymentMethod')}:
                                              </Col>
                                              <Col span={12} style={{textTransform: 'capitalize'}}>
                                                {alert.transaction.medioPago ? alert.transaction.medioPago.toLowerCase() : t('messages.aml.nA')}
                                              </Col>
                                            </div>
                                          </Row>
                                        </Col>
                                      </Col>
                                    }
                                    { rule.params &&
                                      <Col span={12}>
                                        <Col span={24}><h4>{t('messages.aml.modalAlert.alertRules.rejectionDataTitle')}</h4></Col>
                                        <Col span={24}>
                                          <Row className="data" style={{display:"ruby"}}>
                                            { Object.entries(rule.params).map(([key, value], index) =>
                                              getRiskDetailData(key, value, index)
                                            )}
                                          </Row>
                                        </Col>
                                      </Col>
                                    }
                                    { rule.paramsss &&
                                      <Row className="data">
                                        {rule.params.nroTransacciones !== undefined &&
                                          <>
                                            <Col span={12}>
                                                Historia acumulada:
                                            </Col>
                                            <Col span={12}>
                                              {rule.params.nroTransacciones}
                                            </Col>
                                          </>
                                        }
                                        {rule.params.std !== undefined &&
                                          <>
                                            <Col span={12}>
                                                Desviación estandar:
                                            </Col>
                                            <Col span={12}>
                                              {rule.params.std}
                                            </Col>
                                          </>
                                        }
                                        {rule.params.avg !== undefined &&
                                          <>
                                            <Col span={12}>
                                                Promedio:
                                            </Col>
                                            <Col span={12}>
                                              {rule.params.avg}
                                            </Col>
                                          </>
                                        }
                                        {rule.params.situacionLaboral &&
                                          <>
                                            <Col span={12}>
                                                Situación laboral:
                                            </Col>
                                            <Col span={12} style={{textTransform: 'capitalize'}}>
                                              {rule.params.situacionLaboral.toLowerCase()}
                                            </Col>
                                          </>
                                        }
                                        {rule.params.umbralPagos !== undefined &&
                                          <>
                                            <Col span={12}>
                                              Umbral de Pagos:
                                            </Col>
                                            <Col span={12}>
                                              {rule.params.umbralPagos?.toLocaleString('cl')}
                                            </Col>
                                          </>
                                        }
                                        {rule.params.umbralRetiros !== undefined &&
                                          <>
                                            <Col span={12}>
                                              Umbral de Retiros:
                                            </Col>
                                            <Col span={12}>
                                              {rule.params.umbralRetiros?.toLocaleString('cl')+ ' ' +alert.transaction.codMoneda}
                                            </Col>
                                          </>
                                        }
                                        {rule.params.sueldoPromedio !== undefined &&
                                          <>
                                            <Col span={12}>
                                              {t('messages.aml.averageIncome')}:
                                            </Col>
                                            <Col span={12}>
                                              {rule.params.sueldoPromedio.toLocaleString('cl')}
                                            </Col>
                                          </>
                                        }
                                        {rule.params.factorSueldo !== undefined &&
                                          <>
                                            <Col span={12}>
                                              {t('messages.aml.modalAlert.alertRules.salaryTimes')}:
                                            </Col>
                                            <Col span={12}>
                                              {rule.params.factorSueldo}
                                            </Col>
                                          </>
                                        }
                                        {rule.params.ventaPromedio !== undefined &&
                                          <>
                                            <Col span={12}>
                                              {t('messages.aml.averageSale')}:
                                            </Col>
                                            <Col span={12}>
                                              {rule.params.ventaPromedio.toLocaleString('cl')}
                                            </Col>
                                          </>
                                        }
                                        {rule.params.fechaInicioVigencia &&
                                          <>
                                            <Col span={12}>
                                              Inicio vigencia producto:
                                            </Col>
                                            <Col span={12}>
                                              {rule.params.fechaInicioVigencia}
                                            </Col>
                                          </>
                                        }
                                        {rule.params.porcSobreSaldo &&
                                          <>
                                            <Col span={12}>
                                              % sobre el saldo:
                                            </Col>
                                            <Col span={12}>
                                              {rule.params.porcSobreSaldo}
                                            </Col>
                                          </>
                                        }
                                        {rule.params.pais &&
                                          <>
                                            <Col span={12}>
                                              País de Riesgo:
                                            </Col>
                                            <Col span={12} style={{textTransform: 'capitalize'}}>
                                              {rule.params.pais}
                                            </Col>
                                          </>
                                        }
                                        {rule.params.nroCuenta &&
                                          <>
                                            <Col span={12}>
                                              {t('messages.aml.modalAlert.alertRules.accountNumber')}:
                                            </Col>
                                            <Col span={12}>
                                              {rule.params.nroCuenta}
                                            </Col>
                                          </>
                                        }
                                        {rule.params.fechaCierre &&
                                          <>
                                            <Col span={12}>
                                              {t('messages.aml.modalAlert.alertRules.closingDate')}:
                                            </Col>
                                            <Col span={12}>
                                              {moment(rule.params.fechaCierre).format('DD/MM/YYYY')}
                                            </Col>
                                          </>
                                        }
                                        {rule.params.bloqueado && rule.params.bloqueado === 'Y' && 
                                          <>
                                            <Col span={12}>
                                              {t('messages.aml.modalAlert.alertRules.accountStatus')}:
                                            </Col>
                                            <Col span={12}>
                                              {t('messages.aml.modalAlert.alertRules.blocked')}
                                            </Col>
                                          </>
                                        }
                                        {rule.params.pep && rule.params.pep === 'Y' &&
                                        <>
                                          <Col span={12}>
                                            PEP:
                                          </Col>
                                          <Col span={12}>
                                            Sí, ver detalle
                                          </Col>
                                        </>
                                        }
                                      </Row>
                                    }
                                  </Row>
                                </Card>
                            </Col>
                            }
                          </Row>
                      )}
                    </div>
                  </>
                }
                { (alert?.description?.name || alert?.description?.quiebras || alert?.transaction?.msgSwift) &&
                  <Row gutter={[0, 24]}>
                      { alert?.description?.name &&
                        <div style={{padding: 10}}>
                          <Col span={24}>
                            <Descriptions title={t('messages.aml.description')} layout="vertical" size="small" bordered>
                              <Descriptions.Item label={t('messages.aml.modalAlert.alertRules.createdBy')}>
                                { alert?.username ?? t('messages.aml.nA')}
                              </Descriptions.Item>
                              <Descriptions.Item label={t('messages.aml.modalAlert.alertRules.shortDescription')}>
                                { alert?.description?.name ?? t('messages.aml.nA')}
                              </Descriptions.Item>
                              { alert?.description?.description &&
                                <Descriptions.Item label={t('messages.aml.modalAlert.alertRules.longDescription')}>
                                  <p dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(alert?.description?.description?.replace('\n','<br/>'))}}></p>
                                </Descriptions.Item>
                              }
                            </Descriptions>
                          </Col>
                        </div>
                      }
                      { alert?.description?.quiebras &&
                        <div style={{padding: 10}}>
                          <Table
                            columns={quiebrasColumn}
                            dataSource={alert?.description?.quiebras}
                            size="small"
                            pagination={false}
                          />
                        </div>
                      }
                      { alert?.transaction?.msgSwift &&
                        <div style={{padding: 20}}>
                          <Col span={24}>
                            <Descriptions title={ t('messages.aml.transaction') } layout="vertical" size="small" bordered>
                                <Descriptions.Item label={t('messages.aml.modalAlert.alertRules.swiftMessage')}>
                                  { alert?.transaction?.msgSwift ?? t('messages.aml.nA') }
                                </Descriptions.Item>
                                <Descriptions.Item label={t('messages.aml.modalAlert.alertRules.swiftMessageBlock')}>
                                  { alert?.transaction?.blockSwift ?? t('messages.aml.nA') }
                                </Descriptions.Item>
                                <Descriptions.Item label={t('messages.aml.modalAlert.alertRules.swiftLine')}>
                                  { alert?.transaction?.lineSwift ?? t('messages.aml.nA')}
                                </Descriptions.Item>
                            </Descriptions>
                          </Col>
                        </div>
                      }
                  </Row>
                }
                {alert?.risks && alert?.risks.length > 0 &&
                  <div style={{padding: 5}}>
                    <Table
                      columns={alertRiskDetailColumns}
                      dataSource={alert.risks}
                      size="small"
                      pagination={false}
                    />
                  </div>
                }
                {alert?.riskRecords?.length > 0 &&
                <>
                  { tabla1Data?.length > 0 &&
                    <div style={{padding: 5}}>
                      <Table
                        columns={tabla1Columns}
                        dataSource={tabla1Data}
                        size="small"
                        pagination={false}
                        title={() => {
                          return <div className='title-table-section'>
                          <Row>
                              <Col span={24}>
                                {t('messages.aml.modalAlert.alertRules.tableTitle.participatesInClient', {
                                  subject: camelizerHelper(alert.record.nombre),
                                  client: camelizerHelper(currentUser.cliente.name),
                                })}
                              </Col>
                          </Row>
                        </div>
                        }}
                      />
                    </div>
                  }
                  { tabla3Data?.length > 0 &&
                    <div style={{padding: 5}}>
                      <Table
                        columns={tabla3Columns}
                        dataSource={tabla3Data}
                        size="small"
                        pagination={false}
                        title={() => {
                          return <div className='title-table-section'>
                          <Row>
                              <Col span={24}>
                                {t('messages.aml.modalAlert.alertRules.tableTitle.participatesInCounterpartyOfClient', {
                                  subject: camelizerHelper(alert.record.nombre),
                                  client: camelizerHelper(currentUser.cliente.name),
                                })}
                              </Col>
                          </Row>
                        </div>
                        }}
                      />
                    </div>
                  }
                  { tabla2Data?.length > 0 &&
                    <div style={{padding: 5}}>
                      <Table
                        columns={tabla2Columns}
                        dataSource={tabla2Data}
                        size="small"
                        pagination={false}
                        title={() => {
                          return <div className='title-table-section'>
                          <Row>
                              <Col span={24}>
                                {t('messages.aml.modalAlert.alertRules.tableTitle.hasKinshipWith', {
                                  subject: camelizerHelper(alert.record.nombre),
                                })}
                              </Col>
                          </Row>
                        </div>
                        }}
                      />
                    </div>
                  }
                  { tabla2BData?.length > 0 &&
                    <div style={{padding: 5}}>
                      <Table
                        columns={tabla2BColumns}
                        dataSource={tabla2BData}
                        size="small"
                        pagination={false}
                        title={() => {
                          return <div className='title-table-section'>
                          <Row>
                              <Col span={24}>
                                {t('messages.aml.modalAlert.alertRules.tableTitle.relativesParticipateInClient', {
                                  subject: camelizerHelper(alert.record.nombre),
                                  client: camelizerHelper(currentUser.cliente.name),
                                })}
                              </Col>
                          </Row>
                        </div>
                        }}
                      />
                    </div>
                  }
                  { tabla4Data?.length > 0 &&
                    <div style={{padding: 5}}>
                      <Table
                        columns={tabla4Columns}
                        dataSource={tabla4Data}
                        size="small"
                        pagination={false}
                        title={() => {
                          return <div className='title-table-section'>
                          <Row>
                              <Col span={24}>
                                {t('messages.aml.modalAlert.alertRules.tableTitle.relativesParticipateInCounterparty', {
                                  subject: camelizerHelper(alert.record.nombre),
                                })}
                              </Col>
                          </Row>
                        </div>
                        }}
                      />
                    </div>
                  }
                </>
                  
                }
                {alert !== null && (alert.estadoFP === 'PENDIENTE' || alert.estadoFP === 'TRATADO') && origin !== "portal" &&
                  <FalsesPositivesBlock alert={alert} refreshHandler={refreshHandler} updateFP={updateFP} view={"new"} />
                }
            </AnimateHeight>

            { trxDetails && trxDetails.length > 0 &&
              <Modal
                width={700}
                title={"Transacciones"}
                visible={true}
                onCancel={() => setTrxDetails(null)}
                footer={<Button onClick={() => setTrxDetails(null)}>{t('messages.aml.btnClose')}</Button>}
              >
                <Table
                  columns={trxDetailsColumns}
                  dataSource={trxDetails}
                  size="small"
                  pagination={false}
                />
              </Modal>
            }
        </div>
        :
        <div style={{textAlign: 'center', padding: 100}}>
          <Spin size="large"/>
        </div>
      }
      </>
    );
};

export default AlertRules;